// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBocenE-NO5JkU9PtFzTh0aicZgTRgp50U",
  authDomain: "review-boss-c25f1.firebaseapp.com",
  projectId: "review-boss-c25f1",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider, signInWithPopup };
